export { default } from './OrganisationType';
